import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ElDatePicker} from 'element-plus';
import 'element-plus/es/components/date-picker/style/css';

import { StDatePicker } from './date-picker.styled';

export default /*#__PURE__*/_defineComponent({
  __name: 'NkDatePicker',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StDatePicker), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ElDatePicker), _normalizeProps(_guardReactiveProps(_ctx.$attrs)), null, 16)
    ]),
    _: 1
  }))
}
}

})